"use client";

import type { ReactNode } from "react";
import Link, { type LinkProps } from "next/link";
import { useLoadingOptional } from "@/context/LoadingContext";

type Props = LinkProps & {
  children: ReactNode;
  className?: string;
};

function shouldShowRouteLoader(href: LinkProps["href"]): boolean {
  if (typeof href !== "string") return false;
  return href.startsWith("/") && !href.startsWith("//") && !href.includes("#");
}

export default function LoadingLink({ href, onClick, ...rest }: Props) {
  const ctx = useLoadingOptional();

  return (
    <Link
      href={href}
      onClick={(e) => {
        if (ctx && shouldShowRouteLoader(href)) {
          ctx.beginNavigationLoading();
        }
        onClick?.(e);
      }}
      {...rest}
    />
  );
}
